angular.module('siter.io').factory 'Site', ["Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", (Restangular, $rootScope, $stateParams, $state, $modal, $injector) ->
  site =
    _currentSite: Restangular.one('sites', $stateParams.siteId)
    get: (id) ->
      if id
        Restangular.one('sites', id).get()
      else
        Restangular.one('sites', $stateParams.siteId).get()
    getList: ->
      Restangular.all('sites').getList()
    update: (site) ->
      Restangular.all('sites').one(site.id).customPUT site
    updateByRoute: (site) ->
      Restangular.all('sites').one($stateParams.siteId).customPUT site
    remove: (id) ->
      Restangular.one('sites', id).remove()
    create: (site) ->
      Restangular.all('sites').post(site)
    saveIndex: (changes) ->
      Restangular.one('sites', $stateParams.siteId).all('assets/save').post({changes: changes, path: $rootScope.currentFile.full_path})
    transfer: (data) ->
      Restangular.one('sites', $stateParams.siteId).all("transfer").post(data)
    share: (site) ->
      Restangular.one('sites', $stateParams.siteId).all("share").post(site)
    setTemplate: (template_id) ->
      Restangular.all("sites").one($state.params.siteId).customPUT template_id: template_id
    # Create site modal
    addSite: ->
      $state.go "root.new_site"
    clearFonts: ->
      Restangular.all("sites").one($state.params.siteId).all("clear_fonts").post()
    createTemplate: (templateParams) ->
      Restangular.all("sites").one($state.params.siteId).all("templates").post(templateParams)
    publish: ->
      Restangular.all("sites").one($state.params.siteId).all("build").post()
    clone: (site_id) ->
      Restangular.all("sites").one(site_id).all("clone").post()
  site
]



// WEBPACK FOOTER //
// ./src/app/site/site.service.coffee